"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".banerTokenPayment__banerImage.choosen[_ngcontent-%COMP%]{height:200px;width:100%}.banerTokenPayment__banerImage[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{height:100%;background-repeat:no-repeat;background-size:contain}.banerTokenPayment[_ngcontent-%COMP%]   .mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{position:relative}.mat-progress-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%], .mat-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#fff!important}"];
exports.styles = styles;
